import moment from "moment";
import {getPackageName} from "./native";

export function newDate(dateString) {
    let result = new Date(...arguments);
    if (isNaN(result.getTime())) {
        let year = dateString.substr(0, 4);
        let month = dateString.substr(5, 2);
        let day = dateString.substr(8, 2);
        let hour = dateString.substr(11, 2);
        let min = dateString.substr(14, 2);
        let second = dateString.substr(17, 2);
        result = new Date(+year, +month - 1, +day, +hour, +min, +second);
    }
    return result;
}

export function checkVersion (versions, shouldNoVersionShow = true) {

    let currentVersion = localStorage.getItem('version');
    console.log('currentVersion', currentVersion)
    // 返回的值是，是否需要显示升级app版本提示语；true：提示，false：不提示
    if(currentVersion) {
        let source = process.env.VUE_APP_H5_ENV === 'vpa' ? 'vpa' : 'wear3'; // 1：VPA 2：wear3
        let oversea = process.env.VUE_APP_H5_ENV === 'vpa' ? 'cn' : 'oversea'; //0：国内 1：海外
        let platform = sessionStorage.getItem('isiOS') === 'true' ? 'ios' : 'android'; //1：iOS 2：Android
        let currentName = source + '_' + platform + '_' + oversea;
        let minVersion = versions[currentName]; // 显示的最低版本
       // console.log(currentVersion, minVersion, currentName,localStorage.getItem('oversea'))
        if(!minVersion) { // 没有写对应版本号，不需要提示
            if(shouldNoVersionShow) {
                return false;
            }
            else {
                return true;
            }
        }
        else if(currentVersion < minVersion ) { // 当前版本低于要求的最低版本，则需要显示提示语
            return true;
        }
        else {
            return false
        }
    }
    else {
        return true;
    }
}

export function deepClone (obj) {
    if (!obj && typeof obj !== "object") {
        throw new Error("error arguments", "deepClone");
    }
    const targetObj = obj.constructor === Array ? [] : {};
    Object.keys(obj).forEach(keys => {
        if (obj[keys] && typeof obj[keys] === "object") {
            targetObj[keys] = deepClone(obj[keys]);
        } else {
            targetObj[keys] = obj[keys];
        }
    });
    return targetObj;
}

export function isEmptyObject(obj) {
    for (let key in obj) {
        return false;
    }
    return true;
}

export function transformTimestampToMinutes(timestamp) {
    let time = moment(timestamp).format('HH:mm');
    let arr = time.split(":")
    return  Number(Number(arr[0] * 60) + Number(arr[1]))
}


// 与安卓保持一样的计算方法；区别安卓是毫秒，h5是是秒
export function secondsToHourAndMinutes(seconds) {
    let hours = 0;
    let minutes = 0;
    if(seconds > 0) {
        let allMinutes = seconds / 60;
        allMinutes = allMinutes < 1 ? 1 : Math.round(allMinutes);
        hours =  Math.floor(allMinutes / 60);
        minutes = allMinutes % 60;
    }
    return {
        hour: hours,
        minute: minutes
    }
}
export function transferSeconds(value) {
    let result = secondsToHourAndMinutes(value)
    return result.hour ? `${result.hour}${this.$t('message.sleep.hour')} ${result.minute}${this.$t('message.sleep.minute')}` : `${result.minute}${this.$t('message.sleep.minute')}`
}

export function timeFormat(time, format = 'YYYY-MM-DD HH:mm:ss'){
    if(time) {
        return moment(time).format(format);
    }
    else {
        return ''
    }
}

export function secondsToHMS(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return {
        hour: hours,
        minute: minutes,
        seconds: remainingSeconds
    }
}

export async function goToOpenVipPage() {
    let isiOS = sessionStorage.getItem("isiOS");
    const package_name = await getPackageName()
    console.log('goToOpenVipPage',process.env.VUE_APP_H5_ENV)
    const isIosHealthCopilot = process.env.VUE_APP_H5_ENV === 'wear3' && sessionStorage.getItem('isiOS') === 'true' && (!package_name || package_name === 'com.mobvoi.companion.at');
    if (isiOS && isiOS !== "false") {
        let showUpdateTips = checkVersion({
            wear3_ios_oversea: '1.7',
        }, false)
        if (isIosHealthCopilot && !showUpdateTips) {
            console.log('ios hc开通vip')
            window.webkit.messageHandlers.openCoPilotVip.postMessage(null);
        } else {
            console.log('ios h5开通vip')
            window.webkit.messageHandlers.openVipPage.postMessage(null);
        }
    } else {
        console.log('安卓 h5开通vip')
        window.MobvoiJSBridge.openVipPage();
    }
}

export async function goToHcActivityVipPage(id) {
    const package_name = await getPackageName()
    console.log('goToOpenVipPage',process.env.VUE_APP_H5_ENV)
    const isIosHealthCopilot = process.env.VUE_APP_H5_ENV === 'wear3' && sessionStorage.getItem('isiOS') === 'true' && (!package_name || package_name === 'com.mobvoi.companion.at');
        let showActivityUpdateTips = checkVersion({
            wear3_ios_oversea: '1.7.3',
        }, false)
        if(isIosHealthCopilot && !showActivityUpdateTips) {
            console.log('ios hc开通活动vip')
            window.webkit.messageHandlers.openCoPilotActivityVip.postMessage(id || null);
        } else {
            console.log('ios h5开通vip 升级提醒')
            try {
                window.webkit.messageHandlers.openCoPilotActivityVip.postMessage(id || null);
            }
            catch(err) {
                this.$toast(this.$t('message.updateAppTips'))
            }
        }
}

